import { useCallback, useState } from 'react';
const useQuery = () => {
    const [query, setQuery] = useState('');
    const clear = useCallback(() => {
        setQuery('');
    }, []);
    return { query, update: setQuery, clear };
};
export { useQuery };
//# sourceMappingURL=useQuery.js.map